import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const { color, radius } = theme;

const wrap: CSSObject = {
  position: 'relative',
  display: 'inline-flex',
};

const trigger: CSSObject = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 32,
  height: 32,
  borderRadius: radius.sm,
  color: color.grey400,
  transition: 'color 0.15s ease, background-color 0.15s ease',
  ':hover': {
    color: color.grey700,
    background: color.grey75,
  },
};

const bubble = (placement: 'bottom-start' | 'bottom-end'): CSSObject => ({
  position: 'absolute',
  top: 'calc(100% + 6px)',
  ...(placement === 'bottom-start' ? { left: 0 } : { right: 0 }),
  zIndex: 20,
  width: 'max-content',
  maxWidth: 'min(280px, calc(100vw - 32px))',
  padding: '10px 12px',
  borderRadius: radius.md,
  background: color.grey800,
  color: color.white,
  fontSize: 12,
  fontWeight: 500,
  lineHeight: 1.6,
  whiteSpace: 'pre-line',
  wordBreak: 'keep-all',
  boxShadow: theme.shadow.popover,
});

export { wrap, trigger, bubble };
